var map = {
	"./american_autumn_panoramic.webp": 80777,
	"./american_autumn_standard.webp": 75054,
	"./american_city_panoramic.webp": 46868,
	"./american_city_standard.webp": 25037,
	"./american_garden_panoramic.webp": 84254,
	"./american_garden_standard.webp": 38271,
	"./american_mountains_panoramic.webp": 24567,
	"./american_mountains_standard.webp": 25316,
	"./american_pool_panoramic.webp": 55997,
	"./american_pool_standard.webp": 74242,
	"./american_sandy_panoramic.webp": 2294,
	"./american_sandy_standard.webp": 50551,
	"./american_town_panoramic.webp": 61651,
	"./american_town_standard.webp": 78256,
	"./american_village_panoramic.webp": 7439,
	"./american_village_standard.webp": 14588,
	"./boho_city_panoramic.webp": 71660,
	"./boho_city_standard.webp": 83077,
	"./boho_garden_panoramic.webp": 55494,
	"./boho_garden_standard.webp": 16039,
	"./boho_mountains_panoramic.webp": 53615,
	"./boho_mountains_standard.webp": 99164,
	"./boho_pool_panoramic.webp": 91749,
	"./boho_pool_standard.webp": 66730,
	"./boho_sandy_panoramic.webp": 49694,
	"./boho_sandy_standard.webp": 76255,
	"./boho_town_panoramic.webp": 91275,
	"./boho_town_standard.webp": 15816,
	"./boho_village_panoramic.webp": 21415,
	"./boho_village_standard.webp": 5396,
	"./elegance_autumn_panoramic.webp": 433,
	"./elegance_autumn_standard.webp": 24214,
	"./elegance_city_panoramic.webp": 24252,
	"./elegance_city_standard.webp": 86453,
	"./elegance_garden_panoramic.webp": 69142,
	"./elegance_garden_standard.webp": 6711,
	"./elegance_mountains_panoramic.webp": 34975,
	"./elegance_mountains_standard.webp": 29644,
	"./elegance_pool_panoramic.webp": 95541,
	"./elegance_pool_standard.webp": 75706,
	"./elegance_sandy_panoramic.webp": 25934,
	"./elegance_sandy_standard.webp": 5711,
	"./elegance_town_panoramic.webp": 69051,
	"./elegance_town_standard.webp": 46392,
	"./elegance_village_panoramic.webp": 71927,
	"./elegance_village_standard.webp": 7012,
	"./england_city_panoramic.webp": 1343,
	"./england_city_standard.webp": 15916,
	"./england_garden_panoramic.webp": 63257,
	"./england_garden_standard.webp": 1374,
	"./england_mountains_panoramic.webp": 61094,
	"./england_mountains_standard.webp": 64167,
	"./england_pool_panoramic.webp": 51634,
	"./england_pool_standard.webp": 69683,
	"./england_sandy_panoramic.webp": 54299,
	"./england_sandy_standard.webp": 39800,
	"./england_town_panoramic.webp": 73496,
	"./england_town_standard.webp": 76945,
	"./england_village_panoramic.webp": 33918,
	"./england_village_standard.webp": 50911,
	"./japandi_autumn_panoramic.webp": 15812,
	"./japandi_autumn_standard.webp": 69949,
	"./japandi_city_panoramic.webp": 74845,
	"./japandi_city_standard.webp": 66242,
	"./japandi_garden_panoramic.webp": 32727,
	"./japandi_garden_standard.webp": 37988,
	"./japandi_mountains_panoramic.webp": 82580,
	"./japandi_mountains_standard.webp": 77357,
	"./japandi_pool_panoramic.webp": 18308,
	"./japandi_pool_standard.webp": 79293,
	"./japandi_sandy_panoramic.webp": 97681,
	"./japandi_sandy_standard.webp": 40041,
	"./japandi_town_panoramic.webp": 80846,
	"./japandi_town_standard.webp": 42063,
	"./japandi_village_panoramic.webp": 91196,
	"./japandi_village_standard.webp": 37269,
	"./modern_autumn_panoramic.webp": 886,
	"./modern_autumn_standard.webp": 51287,
	"./modern_city_panoramic.webp": 48479,
	"./modern_city_standard.webp": 41644,
	"./modern_garden_panoramic.webp": 11769,
	"./modern_garden_standard.webp": 73182,
	"./modern_mountains_panoramic.webp": 35014,
	"./modern_mountains_standard.webp": 68711,
	"./modern_pool_panoramic.webp": 97362,
	"./modern_pool_standard.webp": 7507,
	"./modern_sandy_panoramic.webp": 84155,
	"./modern_sandy_standard.webp": 36568,
	"./modern_town_panoramic.webp": 20856,
	"./modern_town_standard.webp": 17585,
	"./modern_village_panoramic.webp": 40190,
	"./modern_village_standard.webp": 36351,
	"./scandy_city_panoramic.webp": 8988,
	"./scandy_city_standard.webp": 52885,
	"./scandy_garden_panoramic.webp": 66774,
	"./scandy_garden_standard.webp": 91479,
	"./scandy_mountains_panoramic.webp": 44511,
	"./scandy_mountains_standard.webp": 39596,
	"./scandy_pool_panoramic.webp": 72693,
	"./scandy_pool_standard.webp": 79770,
	"./scandy_sandy_panoramic.webp": 87246,
	"./scandy_sandy_standard.webp": 20783,
	"./scandy_town_panoramic.webp": 84603,
	"./scandy_town_standard.webp": 65304,
	"./scandy_village_panoramic.webp": 16567,
	"./scandy_village_standard.webp": 8452,
	"./zero_city_panoramic.webp": 17768,
	"./zero_city_standard.webp": 82017,
	"./zero_garden_panoramic.webp": 44122,
	"./zero_garden_standard.webp": 24219,
	"./zero_mountains_panoramic.webp": 87947,
	"./zero_mountains_standard.webp": 94888,
	"./zero_pool_panoramic.webp": 86033,
	"./zero_pool_standard.webp": 97590,
	"./zero_sandy_panoramic.webp": 98554,
	"./zero_sandy_standard.webp": 67291,
	"./zero_town_panoramic.webp": 43087,
	"./zero_town_standard.webp": 95292,
	"./zero_village_panoramic.webp": 20859,
	"./zero_village_standard.webp": 70040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64004;